var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"dialog-image",attrs:{"max-width":"500px","overlay-color":"black"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('img',_vm._g(_vm._b({staticClass:"message-image",attrs:{"src":_vm.img}},'img',attrs,false),on))]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('img',{staticClass:"message-full-image",attrs:{"src":_vm.img}})])}
var staticRenderFns = []

export { render, staticRenderFns }